<template>
        <div class="layui-row" id="buttomIndex">
            
                <div class="bbt-container">

                    <!-- <el-row class="bbt-link">
                        <el-row type="flex" justify="space-between" align="middle">
                            <el-col :span="6">
                                <div class="bbt-link__title" data-v-c5902382="">关于我们</div>
                                <ul class="bbt-link__list" data-v-c5902382="">
                                    <li><router-link :to="{path: '/about_detail/1'}" class="" target="_blank">关于平台</router-link></li>
                                </ul>
                            </el-col>

                            <el-col :span="6">
                                <div class="bbt-link__title">联系我们</div>
                                <ul class="bbt-link__list">
                                    <li><router-link :to="{path: '/about_detail/2'}" class="" target="_blank">联系方式</router-link></li>
                                </ul>
                            </el-col>
                            
                            <el-col :span="6">
                                <div class="bbt-link__title">加入我们</div>
                                <ul class="bbt-link__list">
                                    <li><router-link :to="{path: '/about_detail/3'}" class="" target="_blank">欢迎加入</router-link></li>
                                </ul>
                            </el-col>
                                
                            
                            <el-col :span="6">
                                <div class="bbt-link__qrcode">
                                    <img :src="`${publicPath}default/qrcode_for_gh_d329bfba2e7e_258.jpg`" width="88" alt="App 下载" style="display:block;">
                                    <span class="bbt-link__caption">App 下载</span>
                                    <img :src="`${publicPath}default/wx_gongzhonghao.jpg`" width="88" alt="微信公众号" style="display:block;margin-top:16px;">
                                    <span class="bbt-link__caption">微信公众号</span>
                                </div>
                            </el-col>
                        </el-row>
                    </el-row> -->

                    <!-- <div class="bbt-friend">
                        <div class="bbt-friend__item">
                            <span class="item__header"> 友情链接：</span>
                            <ul class="item__list bbt-clearfix">
                                <li v-for="item in buttomLinks" :key="item.value">
                                    <a :href="item.value" target="_blank" rel="noopener noreferrer" class="link-light-minor">{{item.label}}</a>
                                </li>
                            </ul>
                        </div>
                    </div> -->

                    <div class="bbt-copyright">
                         <!-- xxxxxx有限公司 · 署名-非商业性使用-相同方式共享（BY-NC-SA 3.0 CN） · -->
                         版权所有：贵州未来大科普服务有限公司 备案号：
                         <a href="https://beian.miit.gov.cn/#/Integrated/index" rel="noreferrer" target="_blank" class="bbt-copyright__link">
                            黔ICP备2023005812号-1
                        </a>   
                        <a href="https://beian.mps.gov.cn/#/query/webSearch?code=52011202003674" rel="noreferrer" target="_blank" class="bbt-copyright__link mg-l-15">
                            <img src="../assets/beiantubiao.png" width="15" height="15" alt="">
                            贵公网安备52011202003674号
                        </a>
                    </div>
                </div>
                
        </div>
        
</template>

<script>
import { getRelationLink } from '@/api/api'
export default {
    name:'ButtomIndex',
    props:{
        serveHost: String
    },
    data() {
        return {
            publicPath: process.env.BASE_URL,
            buttomLinks:[]
        }
    },
    mounted() {
        getRelationLink({}).then((res) => {
            this.buttomLinks = res.data.data;
        });
    }
}
</script>

<style scoped>
.bbt-copyright, a.bbt-copyright__link {
    font-size: 12px;
    line-height: 20px;
    color: #fff !important;
    opacity: 1;
}

.mg-l-15 {margin-left: 15px;}

    .link-light-minor {
        color: hsla(0,0%,100%,.64);
        transition: all .3s ease;
    }
    .bbt-friend .item__list>li {
        list-style: none;
        float: left;
        padding: 0 8px;
        margin-bottom: 8px;
    }
    .bbt-clearfix:after {
        clear: both;
    }

    .bbt-clearfix:after, .bbt-clearfix:before {
        display: table;
        content: "";
    }
    .bbt-friend .item__list {
        margin: 0 auto;
        padding-left: 60px;
    }
    .bbt-friend .item__header{
        position: absolute;
        top: 0;
        left: 0;
    }
    .bbt-friend__item {
        position: relative;
        margin-bottom: 16px;
        line-height: 10px;
    }
    .bbt-friend {
        margin-top: 32px;
        color: #fff;
        font-size: 12px;
    }
    #buttomIndex{
        background-color:#1e1e1e;
        padding:40px 0;
        margin-top:20px;
    }


    div {
        display: block;
    }

    *, :after, :before {
        box-sizing: border-box;
    }

    @media (min-width: 1200px) {
        .bbt-container {
            width: 1200px;
        }
    }
    
    .bbt-container {
        padding-left: 12px;
        padding-right: 12px;
        margin: 0 auto;
    }

    .bbt-container:after {
        clear: both;
    }

    .bbt-container:after, .bbt-container:before {
        display: table;
        content: "";
    }

    .bbt-row:after, .bbt-row:before {
        content: " ";
        display: table;
    }

    .bbt-row:after {
        clear: both;
    }

    .bbt-link {
        padding-bottom: 16px;
        border-bottom: 1px solid hsla(0,0%,100%,.1);
    }

    .bbt-friend {
        margin-top: 32px;
        color: #fff;
        font-size: 12px;
    }

    .bbt-copyright {
        font-size: 12px;
        line-height: 20px;
        color: #fff;
        opacity: .7;
    }

    .bbt-col-xs-4 {
        float: left;
        flex: 0 0 auto;
        width: 16.66666667%;
    }

    .bbt-link__title {
        color: #fff;
        font-size: 16px;
        line-height: 24px;
        margin-bottom: 16px;
    }

    .bbt-link__list{
        margin: 0 auto;
        padding-left: 0;
        font-size: 14px;
        line-height: 22px;
    }

    .bbt-link__list>li {
        list-style: none;
        margin-bottom: 16px;
    }

    .bbt-link__list>li>a {
        opacity: .7;
        color: #fff;
    }

    .bbt-friend__item {
        position: relative;
        margin-bottom: 16px;
        line-height: 10px;
    }

    .bbt-friend .item__header {
        position: absolute;
        top: 0;
        left: 0;
    }

    .bbt-friend .item__list {
        margin: 0 auto;
        padding-left: 60px;
    }

    .bbt-friend .item__list>li {
        list-style: none;
        float: left;
        padding: 0 8px;
        margin-bottom: 8px;
    }

    .link-light-minor {
        color: hsla(0,0%,100%,.64);
        transition: all .3s ease;
    }

    .bbt-link__caption {
        color: hsla(0,0%,100%,.64);
        font-size: 12px;
        display: inline-block;
        margin-top: 4px;
    }
</style>